interface PromiseConstructor {
    noop<T = void>(): Promise<T>;
    wait(ms: number): Promise<void>;
    wait<T>(ms: number, val: T): Promise<T>;
}

interface AlwaysHandler<T> {
    (res: T): void;
    (res: undefined, error: any): void;
}

interface Promise<T> {
    always(fn: AlwaysHandler<T>): void;
    /**
     * shutdown promise
     * @param [logError=true] - logging if error
     */
    shutdown(logError?: boolean): void;
}

Promise.noop = function() {
    return new Promise<any>(() => {});
};

Promise.wait = function() {
    const ms = arguments[0];
    const val = arguments[1];
    const useValue = arguments.length > 1;
    return new Promise<any>(resolve => {
        _.delay(() => (useValue ? resolve(val) : resolve()), ms);
    });
};

Promise.prototype.always = function(this: Promise<any>, fn: AlwaysHandler<any>) {
    this.then(fn, _.partial(fn, undefined));
};

Promise.prototype.shutdown = function(this: Promise<any>, logError = altosoft.isDebug) {
    if (logError) this.always((...args) => args[1] && console.error(args[1]));
    else this.always($.noop);
};
